import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import { matchPath,withRouter } from 'react-router-dom';
import {getThemeSettingsVariables, hasFeatureAccess} from '../../../common/Global/commonFunctions';
import {TopTabsLayout} from '../../../common/Global/globalStyles.style';

let isInternal ='';
let isStandard ='';
let themeColor = ``;
const nonePrivilege = "NONE";

class MasterTopMenu extends Component{
    constructor(props) {
        super(props);
        this.state = {
        }
        
        isInternal = this.checkActivePath(["/internal"]);
        isStandard = this.checkActivePath("/standard");
    }

    checkActivePath = (path) =>{
        const themeSettings = getThemeSettingsVariables();
        themeColor = `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`;
        return matchPath(this.props.history.location.pathname, { path });
    }

    render(){
        let width="40%";
        return(
            <TopTabsLayout themeSettings={this.props.themeSettings}>
                <div className="question-tabs"  style={{marginRight:0}}>
                    <ul style={{width:width}}>
                        {(hasFeatureAccess(Constants.FEATURE_INTERNAL_FRAMEWORK) && 
                        this.props.menus[Constants.SCREEN_INTERNAL_FRAMEWORK] !== nonePrivilege) &&

                            <li className={isInternal? "questiontab-active" : ""}>
                                <a href={Constants.URL_INTERNAL}
                                    style={{color: !isInternal ? themeColor : '', fontWeight: !isInternal ? "bold" : "100px"}}>Internal</a>
                            </li>
                        }
                        {(hasFeatureAccess(Constants.FEATURE_STANDARD_FRAMEWORK) &&
                        this.props.menus[Constants.SCREEN_STANDARD_FRAMEWORK] !== nonePrivilege) &&
                            <li className={isStandard ? "questiontab-active" : ""}>
                                <a href={Constants.URL_STANDARD}
                                    style={{color: !isStandard ? themeColor : '', fontWeight: !isStandard ? "bold" : "100px"}}>Standard</a>
                            </li>
                        }
                    </ul>
                </div>
            </TopTabsLayout>
        )
    }
}

export default withRouter(MasterTopMenu);